import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-6c9536e7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "fs-4 text-black fw-semibold mb-20" }, "Détails et réponses de la session", -1))
const _hoisted_4 = {
  key: 0,
  class: "text-center"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-10" }, "Chargement...", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-primary",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Chargement...")
], -1))
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "row mb-20" }
const _hoisted_10 = { class: "col-md-6" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Nombre de questions :", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Date de création :", -1))
const _hoisted_13 = { class: "col-md-6" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Score :", -1))
const _hoisted_16 = { key: 1 }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Bonnes réponses :", -1))
const _hoisted_18 = { key: 2 }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Mauvaises réponses :", -1))
const _hoisted_20 = { key: 3 }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Date :", -1))
const _hoisted_22 = { key: 4 }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Statut :", -1))
const _hoisted_24 = { class: "mb-20" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "attemptSelect",
  class: "text-black fw-semibold mb-10"
}, "Sélectionner une tentative :", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "0" }, "Session originale", -1))
const _hoisted_27 = ["value"]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "mb-10" }, "Questions et réponses", -1))
const _hoisted_29 = {
  key: 0,
  class: "table-responsive"
}
const _hoisted_30 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Contenu "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Réponse ")
  ])
], -1))
const _hoisted_32 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_33 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_34 = {
  key: 0,
  class: "mt-5 text-success"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Bonne réponse :", -1))
const _hoisted_36 = { class: "fw-bold" }
const _hoisted_37 = {
  key: 1,
  class: "alert alert-info"
}
const _hoisted_38 = { class: "d-flex justify-content-center gap-2 mt-20" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-arrow-left me-1" }, null, -1))
const _hoisted_40 = {
  key: 2,
  class: "alert alert-danger text-center"
}
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Session non trouvée", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Aucune session ne correspond à cet identifiant.", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_7))
        : (_ctx.session)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("p", null, [
                    _hoisted_11,
                    _createTextVNode(" " + _toDisplayString(_ctx.session.count), 1)
                  ]),
                  _createElementVNode("p", null, [
                    _hoisted_12,
                    _createTextVNode(" " + _toDisplayString(_ctx.format_date(_ctx.session.createdAt)), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  (_ctx.selectedResult)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_14, [
                        _hoisted_15,
                        _createTextVNode(" " + _toDisplayString(_ctx.selectedResult.score) + " / " + _toDisplayString(_ctx.selectedResult.total) + " (" + _toDisplayString(_ctx.selectedResult.percentage) + "%)", 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.selectedResult)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_16, [
                        _hoisted_17,
                        _createTextVNode(" " + _toDisplayString(_ctx.selectedResult.correctAnswers), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.selectedResult)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_18, [
                        _hoisted_19,
                        _createTextVNode(" " + _toDisplayString(_ctx.selectedResult.incorrectAnswers), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.selectedResult)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_20, [
                        _hoisted_21,
                        _createTextVNode(" " + _toDisplayString(_ctx.selectedResult.updatedAt ? _ctx.format_date(_ctx.selectedResult.updatedAt) : 'N/A'), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("p", _hoisted_22, [
                        _hoisted_23,
                        _createTextVNode(" Aucun résultat disponible pour cette tentative")
                      ]))
                ])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _hoisted_25,
                _withDirectives(_createElementVNode("select", {
                  id: "attemptSelect",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedAttempt) = $event)),
                  class: "form-select shadow-none text-black rounded-0",
                  onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.loadResponsesForAttempt && _ctx.loadResponsesForAttempt(...args)))
                }, [
                  _hoisted_26,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredResultHistory, (result) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: result.attempt,
                      value: result.attempt
                    }, " Reprise " + _toDisplayString(result.attempt), 9, _hoisted_27))
                  }), 128))
                ], 544), [
                  [_vModelSelect, _ctx.selectedAttempt]
                ])
              ]),
              _hoisted_28,
              (_ctx.questionsWithAnswers.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                    _createElementVNode("table", _hoisted_30, [
                      _hoisted_31,
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.questionsWithAnswers, (question, index) => {
                          return (_openBlock(), _createElementBlock("tr", { key: index }, [
                            _createElementVNode("td", _hoisted_32, _toDisplayString(question.contenu), 1),
                            _createElementVNode("td", _hoisted_33, [
                              _createElementVNode("span", {
                                class: _normalizeClass(['text-black', { 'incorrect-strikethrough': !question.isCorrect }])
                              }, _toDisplayString(question.userAnswerText || 'Non répondu'), 3),
                              (!question.isCorrect && question.correctAnswerText)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                    _hoisted_35,
                                    _createTextVNode(),
                                    _createElementVNode("span", _hoisted_36, _toDisplayString(question.correctAnswerText), 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_37, " Aucune réponse disponible pour cette tentative. ")),
              _createElementVNode("div", _hoisted_38, [
                _createVNode(_component_router_link, {
                  to: "/liste-sessions",
                  class: "btn btn-primary"
                }, {
                  default: _withCtx(() => [
                    _hoisted_39,
                    _createTextVNode(" Retour ")
                  ]),
                  _: 1
                })
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_40, [
              _hoisted_41,
              _hoisted_42,
              _createVNode(_component_router_link, {
                to: "/liste-sessions",
                class: "btn btn-primary"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Retour à la liste ")
                ]),
                _: 1
              })
            ]))
    ])
  ]))
}